import { z } from 'zod'
import { Id, Timestamp } from './common'

/*
 * Passkeys (docs/passkeys.md). The WebAuthn JSON itself is checked by the
 * server's WebAuthn library, not here: these schemas carry it through.
 */
const WebAuthnJson = z.record(z.string(), z.unknown())

/** Options for the device, and the challenge they belong to. */
export const PasskeyOptions = z.object({
  challenge_id: Id,
  options: WebAuthnJson,
})
export type PasskeyOptions = z.infer<typeof PasskeyOptions>

export const RegisterPasskeyBody = z.object({
  challenge_id: Id,
  /** What to call it, so it can be told from the others later. */
  name: z.string().trim().min(1, 'Give the passkey a name.').max(60),
  response: WebAuthnJson,
})
export type RegisterPasskeyBody = z.infer<typeof RegisterPasskeyBody>

export const PasskeyLoginBody = z.object({
  challenge_id: Id,
  response: WebAuthnJson,
})
export type PasskeyLoginBody = z.infer<typeof PasskeyLoginBody>

export const Passkey = z.object({
  id: Id,
  name: z.string(),
  /** Synced to a password manager or account, rather than tied to one device. */
  backed_up: z.boolean(),
  created_at: Timestamp,
  last_used_at: Timestamp.nullable(),
})
export type Passkey = z.infer<typeof Passkey>

export const PasskeyList = z.object({ passkeys: z.array(Passkey) })
export type PasskeyList = z.infer<typeof PasskeyList>
